import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { COACHING_TYPE_LIST, CoachingType } from '@app-core/constants/constants';
import { MixPanelService } from '@app-core/services/mixpanel/mix-panel.service';

@Component({
  selector: 'app-coaching-type-filter',
  templateUrl: './coaching-type-filter.component.html',
  styleUrls: ['./coaching-type-filter.component.scss'],
})
export class CoachingTypeFilterComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public coachingType = new FormControl(CoachingType.SELF);
  public selectedType: CoachingType = CoachingType.SELF;
  public coachingTypeList = COACHING_TYPE_LIST;

  @Output() public selectedCoachingType: EventEmitter<any> = new EventEmitter();

  constructor(private mixpanelService: MixPanelService) {}

  async ngOnInit() {
    if (this.coachingType) {
      this.coachingType.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((val) => {
        this.selectedType = this.coachingTypeList.filter((x) => x.value === val)[0].value;
        this.selectedCoachingType.emit(this.selectedType);
      });
      this.mixpanelService.track('Change Coaching Type Filter', {
        'Coaching Type': this.selectedType,
      });
    }
  }
}
